import * as React from 'react';

import type { IconProps } from './types';

export const Folder = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M341.576 73.169h-56.954c-40.472 0-74.167 0-100.937 3.608-28.282 3.803-53.784 12.19-74.264 32.67s-28.867 45.982-32.67 74.264c-3.608 26.77-3.608 60.465-3.608 100.937v364.837c0 61.538 0 111.177 5.266 150.187 5.413 40.57 17.067 74.606 44.178 101.766 27.063 27.112 61.196 38.766 101.717 44.13 39.01 5.266 88.649 5.266 150.187 5.266h275.017c61.538 0 111.177 0 150.187-5.266 40.521-5.364 74.606-17.067 101.717-44.13 27.112-27.112 38.766-61.196 44.178-101.717 5.266-39.01 5.266-88.698 5.266-150.187V532.018c0-61.489 0-111.177-5.266-150.187-5.413-40.472-17.067-74.606-44.178-101.669-27.112-27.112-61.196-38.766-101.717-44.227-39.01-5.218-88.649-5.218-150.187-5.218h-62.757c-13.41 0-21.016-.049-26.673-.585a27.709 27.709 0 0 1-4.726-.773l.191.041-.488-.195h-.098a28.766 28.766 0 0 1-3.205-3.855l-.062-.095c-4.17-6.156-8.742-13.644-12.995-21.333l-.804-1.586-13.068-22.821c-11.947-20.968-22.138-38.766-32.037-52.76-10.581-14.872-22.333-27.502-38.424-36.864s-32.914-13.263-51.054-15.019c-17.115-1.707-37.595-1.707-61.733-1.707z"
        fill={color}
      />
    </svg>
  )
);

export default Folder;
